(function($) {
$(document).ready(function() {

var $$ = {};
$$.body = $('body');
$$.chips = $('#chips');
$$.allChips = $$.chips.find('.chip');
$$.target = $('#target');
$$.flash = $('#flash');

// Adjust color brightness
function adjustBrightness(rgbVal, level) {
	var rgb = [], c;
	rgbVal.replace(/\d+/gi, function(num) {
		rgb.push(parseFloat(num));
		return num;
	});
	for (c = 0; c < rgb.length; c +=1) {
		rgb[c] += (255 * level);
		if (rgb[c] > 255) {
			rgb[c] = 255;
		} else if (rgb[c] < 0) {
			rgb[c] = 0;
		}
		rgb[c] = Math.round(rgb[c]);
	}
	return 'rgb(' + rgb.join(',') + ')';
}

// DEFINE DRAG/DROP ELEMENTS
$$.allChips.draggable();
$$.target.droppable();
$$.chips.disableSelection();

// ON DRAG OVER
$$.target.on('dropover', function() {
	$(this).addClass('over');
});
// ON DRAG OUT
$$.target.on('dropout', function() {
	$(this).removeClass('over');
});

// SHOW CHIP ON MOUSE DOWN
$$.chips.on('mousedown', '.chip', function() {
	$('.chip.current').removeClass('current');
	$(this).addClass('current');
});

// ON DROP
$$.target.on('drop', function(event, ui) {
	var chip, $chip, chipId, chipH,
		cSet, sName,
		color,
		speed
		
	chip = ui.draggable;
	$chip = $(chip);
	chipId = chip[0].id;
	speed = 750;
	
	color = $(chip).css('background-color');
		
	// SHRINK CHIP
	chipH = chip.height();
	chip.animate({
		margin: (chipH / 2),
		// the size is left at 1px to keep its form on the page
		width: 1,
		height: 1
	}, 500, function() {
	
		// PREPARE CHIP REGENERATION
		chip.css({
			opacity:  0,
			width:  chipH,
			height:  chipH,
			margin:  0,
			left:  0,
			top:  0,
		});
		
		// REGENERATE CHIP
		chip.animate({
			opacity: 1
		}, speed);
		
		// HANDLE MULTIPLE CHIPS
		$$.flash.stop();
				
		// CHANGE ELEMENT COLORS
		$$.target.removeClass('over');
		$$.body.animate({
			backgroundColor: adjustBrightness(color, -0.35),
			color: color
		}, speed);
		
		$$.target.animate({
			borderColor: color
		}, 250);
		
		$$.flash
		.css({
			opacity: 1.0,
			backgroundColor: color
		})
		.fadeTo(speed, 0.0);
			
	});

});

});
})(jQuery);
